import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";

class RouteLoadBoundary extends React.Component {
  state = { failed: false, pathname: this.props.pathname };
  static getDerivedStateFromError() { return { failed: true }; }
  static getDerivedStateFromProps({ pathname }, state) {
    // Clear a previous page's failure without remounting healthy account,
    // draft and navigation-list state when the selected route changes.
    if (pathname !== state.pathname) return { failed: false, pathname };
    return null;
  }
  render() {
    if (this.state.failed) {
      return <main style={{ padding: "2rem" }}>
        <h1>This page could not load</h1>
        <p role="alert">Check your connection and reload to get the latest version of PhacoTrainer.</p>
        <button type="button" onClick={() => window.location.reload()}>Reload page</button>
      </main>;
    }
    return this.props.children;
  }
}

export default function RouteLoader({ children }) {
  const { pathname } = useLocation();
  return <RouteLoadBoundary pathname={pathname}>
    <Suspense fallback={<main style={{ padding: "2rem" }}><p role="status">Loading page…</p></main>}>
      {children}
    </Suspense>
  </RouteLoadBoundary>;
}
